// import "../assets/css/style.css";


const serviceCards = [
  { id: 1, title: "Beginner-Focused Learning", description: "Step-by-step resources that turn market concepts into clear understanding." },
  { id: 2, title: "Secure & Transparent", description: "Your safety comes first. Trade confidently with strong encryption and fair practices." },
  { id: 3, title: "All-in-One Platform", description: "Access Forex, Crypto, and Stock trading, all from one intuitive dashboard." },
  { id: 4, title: "Guided by Experts", description: "Learn, trade, and grow with the mentorship of experienced traders." },
  { id: 5, title: "Real-Time Insights", description: "Stay ahead with live market data, smart analytics, and timely updates that help you make informed decisions." },
  { id: 6, title: "Seamless Experience", description: "Enjoy smooth navigation, quick executions, and 24/7 support designed to keep your trading uninterrupted and stress-free." },
];

const QualityProcessSection = () => {
  return (
    <section className="quality-section">
      <div className="quality-header">
        <h1>Trade confidently with a platform you can trust</h1>
        <p>
           Gain full control of your trades with simple tools, transparent pricing, and reliable support from The Pips
        </p>
      </div>

      <div className="quality-grid">
        <div className="quality-column left">
          {serviceCards.slice(0, 3).map((card) => (
            <div key={card.id} className="quality-card">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>

        <div className="quality-center">
          <img src="/images/home/home3.png" alt="Kalite Süreç Görseli" />
        </div>

        <div className="quality-column right">
          {serviceCards.slice(3, 6).map((card) => (
            <div key={card.id} className="quality-card">
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QualityProcessSection;
